import BasicContentVideo from './BasicContentVideo';

export { type BasicContentVideoProps } from './BasicContentVideo';
export default BasicContentVideo;
